import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import { and, not } from 'ramda';
import moment from 'moment';
import {
  renderTextField,
  renderSelectField,
  renderCLDatePickerField,
  validateDateOfBirthNoRequired,
} from '../../utils/redux-form-helper';

type Props = {
  field: string,
  onDelete: Function,
  suffixList: Array<Object>,
  minorRelationshipList: Array<Object>,
  affordableRelationship: Array<Object>,
  fieldsReadOnly: boolean,
  isNew: boolean,
  isAffordable: boolean,
  leaseLocked: boolean,
};

const Minor = ({
  field,
  suffixList,
  minorRelationshipList,
  affordableRelationship,
  onDelete,
  isNew,
  fieldsReadOnly,
  isAffordable,
  leaseLocked,
  fieldAffordableRelationshipShow,
  agingUpMinors = false,
}: Props) => {
  const disableFields = and(not(isNew), fieldsReadOnly);
  return (
    <Row>
      <div className="container-of-inputs">
        <Col xs={6} sm={2}>
          <Field
            name={`${field}.firstName`}
            component={renderTextField}
            maxLength="35"
            disabled={disableFields || leaseLocked}
          />
        </Col>
        <Col xs={6} sm={2}>
          <Field
            name={`${field}.middleName`}
            component={renderTextField}
            maxLength="35"
            disabled={disableFields || leaseLocked}
          />
        </Col>
        <Col xs={6} sm={2}>
          <Field
            name={`${field}.lastName`}
            component={renderTextField}
            maxLength="35"
            disabled={disableFields || leaseLocked}
          />
        </Col>
        <Col xs={6} sm={1}>
          <Field
            name={`${field}.suffixId`}
            component={renderSelectField}
            options={suffixList}
            disabled={disableFields || leaseLocked}
          />
        </Col>
        <Col xs={6} sm={1}>
          <Field
            name={`${field}.preferredName`}
            component={renderTextField}
            maxLength="35"
            disabled={disableFields || leaseLocked}
          />
        </Col>
        {fieldAffordableRelationshipShow && (
          <Col xs={6} sm={1}>
            <Field
              name={`${field}.affordableRelationship`}
              component={renderSelectField}
              options={affordableRelationship}
              disabled={leaseLocked}
            />
          </Col>
        )}
        <Col xs={6} sm={agingUpMinors ? 1 : 2}>
          <Field
            name={`${field}.relationship`}
            component={renderSelectField}
            options={minorRelationshipList}
            disabled={leaseLocked}
          />
        </Col>
        {agingUpMinors ? (
          <Col xs={6} sm={2}>
            <Field
              format={(value) => (value ? moment.utc(value) : null)}
              name={`${field}.birthday`}
              component={renderCLDatePickerField}
              validate={validateDateOfBirthNoRequired}
              disableFuture
              disabled={disableFields || leaseLocked}
              sx={{
                '& .MuiInputBase-root': {
                  height: '32px',
                },
                '& .MuiInputBase-input': {
                  height: '100%',
                },
              }}
            />
          </Col>
        ) : (
          <Col xs={6} sm={1}>
            <Field
              name={`${field}.age`}
              component={renderTextField}
              maxLength="35"
              disabled={disableFields || leaseLocked}
            />
          </Col>
        )}
      </div>
      <div className="container-of-trash">
        <div className="row-remove-btn">
          <a onClick={onDelete} disabled={leaseLocked}>
            <i className="et-trash" />
          </a>
        </div>
      </div>
    </Row>
  );
};

export default Minor;
